import { IndicationType } from '../enums';
import { TreatmentScanType } from '../enums/treatment';

export function convertTreatmentScanToIndication(scan: TreatmentScanType): IndicationType[] {
  switch (scan) {
    case TreatmentScanType.UpperJaw:
    case TreatmentScanType.PreppedUpperJaw:
      return [IndicationType.RemovableDieModel, IndicationType.Scan, IndicationType.Upperscan];

    case TreatmentScanType.LowerJaw:
    case TreatmentScanType.PreppedLowerJaw:
      return [IndicationType.RemovableDieModel, IndicationType.Scan, IndicationType.Lowerscan];

    case TreatmentScanType.BiteScanCombo:
      return [IndicationType.Scan, IndicationType.Bitescan];

    default:
      return [];
  }
}
